/* Nextclubs Set Builder (v1.1)
   Fixes:
   - Light CI-ish design (turquoise) handled in section CSS
   - No preselection: user must choose everything
   - Strict category filtering by fit.club_type
   - Flex fetched + used (fit.flex_raw) and filtered sensibly
   - Back button works + restores previous selections
   - Add-to-cart works: convert Storefront GID to numeric ID
*/
(() => {
  const root = document.querySelector('.nc-builder[id^="nc-builder-"]');
  if (!root) return;

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));

  const CFG = {
    apiVersion: root.dataset.storefrontApiVersion || "2026-01",
    token: root.dataset.storefrontToken || "",
    collections: {
      all: root.dataset.collectionAll || "builder",
      driver: root.dataset.collectionDriver || "",
      fairway_wood: root.dataset.collectionFairway || "",
      hybrid: root.dataset.collectionHybrid || "",
      iron_set: root.dataset.collectionIron || "",
      wedge: root.dataset.collectionWedge || "",
      putter: root.dataset.collectionPutter || ""
    },
    contactSuccessUrl: root.dataset.contactSuccessUrl || ""
  };

  const CATEGORY = {
    driver: { key: "driver", label: "Driver", share: 0.20, needsFlex: true },
    fairway_wood: { key: "fairway_wood", label: "Fairwayholz", share: 0.125, needsFlex: true, needsClubNumber: true },
    hybrid: { key: "hybrid", label: "Hybrid", share: 0.125, needsFlex: true, needsClubNumber: true },
    iron_set: { key: "iron_set", label: "Eisensatz", share: 0.35, needsFlex: true, needsHcp: true, needsLength: true },
    wedges: { key: "wedge", label: "Wedges", share: 0.10, needsFlex: false, needsLoft: true, needsLength: true, hasSubsteps: true },
    putter: { key: "putter", label: "Putter", share: 0.10, needsFlex: false, needsPutterType: true }
  };

  const HCP_BANDS = [
    { key: "0-9", label: "0–9 (Fortgeschritten)" },
    { key: "10-18", label: "10–18 (Ambitioniert)" },
    { key: "19-28", label: "19–28 (Hobbyspieler)" },
    { key: "29-54", label: "29–54 (Einsteiger)" }
  ];

  const SPEED_BUCKETS = [
    { key: "slow", label: "Langsam (< 80 mph 7i)" },
    { key: "moderate", label: "Moderat (80–92 mph 7i)" },
    { key: "fast", label: "Schnell (> 92 mph 7i)" }
  ];

  const LENGTH_BY_HEIGHT_CM = [
    { max: 160, val: "-1\"" },
    { max: 168, val: "-0.5\"" },
    { max: 187, val: "Standard" },
    { max: 192, val: "+0.5\"" },
    { max: 197, val: "+0.75\"" },
    { max: 999, val: "+1\"" }
  ];

  // --------- State (NO PRESELECTION) ----------
  const state = {
    step: 0,
    setType: null, // full | half | custom
    categories: [], // chosen by user
    currentCatIndex: 0,
    wedgeSubstep: 0,
    includeLW: false,
    usedFlexFallback: false,
    profile: {
      gender: null,      // men | women
      hand: null,        // RH | LH
      hcpBand: null,     // "29-54" ...
      heightCm: null,
      speedMph7i: null,
      speedBucket: null,
      budget: null,
      brands: [],
      putterType: null   // blade | mallet
    },
    selected: [] // items added via builder
  };

  const ui = {
    main: $('.nc-main'),
    back: $$('[data-action="back"]'),
    next: $$('[data-action="next"]'),
    skip: $$('[data-action="skip"]'),
    stepper: $$('.nc-stepper__item'),
    used: $('.nc-budget__used'),
    total: $('.nc-budget__total'),
    rest: $('.nc-budget__rest'),
    barFill: $('.nc-budget__barFill'),
    modal: $('.nc-modal'),
    toast: $('.nc-toast'),
    contactForm: $('#nc-contact-form'),
    contactMessage: $('#nc-contact-message')
  };

  // ---------- Helpers ----------
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (m) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const dedupe = (arr) => Array.from(new Set(arr));

  

  

  function scheduleScrollTop() {
    // Run after DOM updates/layout so the scroll actually happens
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          // focus something near the top without scrolling (prevents browser keeping focus at bottom buttons)
          const focusEl = root.querySelector('.nc-main') || root;
          if (focusEl) {
            focusEl.setAttribute('tabindex','-1');
            focusEl.focus({ preventScroll: true });
          }
        } catch(e) {}
        scrollToBuilderTop();
      });
    });
  }

  function scrollToBuilderTop() {
    try {
      root.scrollIntoView({ behavior: 'auto', block: 'start' });
      window.scrollBy({ top: -120, left: 0, behavior: 'auto' });
    } catch (e) {}
  }
function unbox(val) {
    if (val == null) return null;
    if (typeof val !== "string") return val;
    let s = val.trim();
    if (!s) return null;

    // Weclapp-Import kann so aussehen: ["7W"] oder ["Stiff"] (inkl. Klammern/Anführungszeichen)
    // Oder sogar nochmal als String: "\"[\\\"7W\\\"]\""
    if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
      s = s.slice(1, -1).trim();
    }

    if (s.startsWith("[") && s.endsWith("]")) {
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr) && arr.length) return arr[0];
      } catch (e) {}

      // Fallback: manuell Klammern/Quotes entfernen
      s = s.replace(/^\[\s*/, "").replace(/\s*\]$/, "").trim();
      s = s.replace(/^["']|["']$/g, "").trim();
      return s || null;
    }

    s = s.replace(/^["']|["']$/g, "").trim();
    return s || null;
  }

function moneyEUR(amount) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(amount||0)); }
    catch { return `${amount}€`; }
  }

  // Anzeige-Score: macht aus dem internen Roh-Score einen vertraulichen 0–100 Wert.
  // Wichtig: Sortierung bleibt nach Roh-Score, wir ändern nur die Darstellung.
  function toFitPercent(rawScore) {
    const x = Number(rawScore || 0);
    // Logistic mapping: x=0 -> 50, x=25 -> ~73, x=40 -> ~83, x=60 -> ~92
    const k = 22;
    const s = 1 / (1 + Math.exp(-(x) / k));
    const pct = Math.round(s * 100);
    return Math.max(0, Math.min(100, pct));
  }


  function toast(title, msg) {
    ui.toast.innerHTML = `<strong>${esc(title)}</strong><div class="nc-small">${esc(msg || "")}</div>`;
    ui.toast.hidden = false;
    setTimeout(() => { ui.toast.hidden = true; }, 2600);
  }

  function getHeightLengthClass(cm) {
    const x = Number(cm || 0);
    for (const r of LENGTH_BY_HEIGHT_CM) if (x <= r.max) return r.val;
    return "Standard";
  }

  function parseBool(val) {
    if (typeof val === "boolean") return val;
    const s = String(val ?? "").toLowerCase().trim();
    return s === "true" || s === "1" || s === "yes";
  }

  function parseNum(val) {
    if (val == null) return null;
    const s = String(val).replace(",", ".").trim();
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }

  function parseListMaybe(val) {
    if (val == null) return [];
    let s = String(val).trim();
    if (!s) return [];

    // Handle quoted JSON strings, z.B. "\"[\\\"7W\\\"]\""
    if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
      s = s.slice(1, -1).trim();
    }

    if (s.startsWith("[")) {
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr)) {
          return arr.map(v => String(unbox(v) ?? v).trim()).filter(Boolean);
        }
      } catch (e) {}
    }

    // Fallback: CSV-like "a,b,c"
    return s
      .split(/[,;|\n]+/)
      .map(x => String(unbox(x) ?? x).trim())
      .filter(Boolean);
  }


  function toNumericVariantId(id) {
    if (!id) return null;
    const s = String(id);
    const m = s.match(/(\d+)\s*$/);
    return m ? m[1] : s;
  }

  function normalizeClubType(v) {
    const s = String(v ?? "").toLowerCase().trim();
    const t = s
      .replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss")
      .replace(/[\s\-]+/g,"_");
    const map = {
      "driver":"driver",
      "drivers":"driver",
      "fairway":"fairway_wood",
      "fairway_wood":"fairway_wood",
      "fairwayholz":"fairway_wood",
      "fairway_holz":"fairway_wood",
      "holz":"fairway_wood",
      "hybrid":"hybrid",
      "hybride":"hybrid",
      "iron_set":"iron_set",
      "ironset":"iron_set",
      "irons":"iron_set",
      "eisensatz":"iron_set",
      "eisen":"iron_set",
      "wedge":"wedge",
      "wedges":"wedge",
      "putter":"putter"
    };
    return map[t] || t || null;
  }

  function normalizeGender(v) {
    const s = String(v ?? "").toLowerCase().trim();
    if (s === "men" || s === "herren") return "men";
    if (s === "women" || s === "damen") return "women";
    return null;
  }

  function normalizeHand(v) {
    const s = String(v ?? "").toUpperCase().trim();
    if (s === "RH" || s === "R" || s.includes("RECHT")) return "RH";
    if (s === "LH" || s === "L" || s.includes("LINK")) return "LH";
    return null;
  }

  function normalizeFlexRaw(v) {
    const s = String(v ?? "").toUpperCase().trim();
    if (!s) return null;
    if (["L","W","UL","A","R2","R3","R","S","X"].includes(s)) return s;
    if (s.includes("REG")) return "R";
    if (s.includes("STIFF")) return "S";
    if (s.includes("XSTIFF") || s.includes("X-STIFF")) return "X";
    if (s.includes("SENIOR")) return "R3";
    if (s.includes("LADIES")) return "L";
    return s;
  }

  // Flex policy
  function allowedFlexes(gender, speedBucket) {
    if (gender === "men") {
      if (speedBucket === "slow") return ["R3","A","R2","R"];
      if (speedBucket === "moderate") return ["R","S"];
      return ["S","X"];
    } else {
      if (speedBucket === "slow") return ["L","W","UL"];
      if (speedBucket === "moderate") return ["L","W","UL","R"];
      return ["R","S","X"];
    }
  }

  function flexScore(flexRaw, gender, speedBucket) {
    const f = normalizeFlexRaw(flexRaw);
    if (!f) return 0;
    const pref = allowedFlexes(gender, speedBucket);
    const idx = pref.indexOf(f);
    if (idx === -1) return -18;
    return 20 - idx * 4;
  }

  function productMetafieldsToObj(node) {
    const mf = node.__metafields || {};
    return {
      club_type: normalizeClubType(unbox(mf.club_type)),
      gender: normalizeGender(unbox(mf.gender)),
      hand: normalizeHand(unbox(mf.hand)),
      available_for_builder: parseBool(unbox(mf.available_for_builder)),
      hcp_bands: parseListMaybe(mf.hcp_bands),
      iron_profile: unbox(mf.iron_profile) || null,
      iron_profiles: parseListMaybe(mf.iron_profiles),
      wedge_type: (String(unbox(mf.wedge_type) || "")).toLowerCase().trim() || null,
      loft_deg: parseNum(unbox(mf.loft_deg)),
      club_number: (String(unbox(mf.club_number) || "")).toUpperCase().trim() || null,
      length_class: unbox(mf.length_class) || null,
      putter_type: (String(unbox(mf.putter_type) || "")).toLowerCase().trim() || null,
      flex_raw: normalizeFlexRaw(unbox(mf.flex_raw))
    };
  }


  // ---------- Storefront API ----------
  function storefrontEndpoint() {
    return `${window.location.origin}/api/${CFG.apiVersion}/graphql.json`;
  }

  async function storefrontFetch(query, variables) {
    if (!CFG.token) throw new Error("Storefront Access Token fehlt. Bitte im Section-Setting hinterlegen.");
    const res = await fetch(storefrontEndpoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Shopify-Storefront-Access-Token": CFG.token
      },
      body: JSON.stringify({ query, variables })
    });
    const json = await res.json();
    if (json.errors?.length) {
      console.error(json.errors);
      throw new Error(json.errors[0].message || "Storefront API Fehler");
    }
    return json.data;
  }

  function collectionHandleForCategory(catKey) {
    if (catKey === "wedges") return CFG.collections.wedge || "";
    if (catKey === "driver") return CFG.collections.driver || "";
    if (catKey === "fairway_wood") return CFG.collections.fairway_wood || "";
    if (catKey === "hybrid") return CFG.collections.hybrid || "";
    if (catKey === "iron_set") return CFG.collections.iron_set || "";
    if (catKey === "putter") return CFG.collections.putter || "";
    return "";
  }

  async function fetchProductsFromCollection(handle) {
    const query = `
      query BuilderCollection($handle: String!, $first: Int!, $after: String, $filters: [ProductFilter!]) {
        collection(handle: $handle) {
          products(first: $first, after: $after, filters: $filters) {
            pageInfo { hasNextPage endCursor }
            nodes {
              id handle title vendor productType availableForSale
              featuredImage { url altText }
              priceRange { minVariantPrice { amount currencyCode } }
              variants(first: 1) { nodes { id availableForSale } }

              mf_club_type: metafield(namespace:"fit", key:"club_type") { value }
              mf_gender: metafield(namespace:"fit", key:"gender") { value }
              mf_hand: metafield(namespace:"fit", key:"hand") { value }
              mf_available_for_builder: metafield(namespace:"fit", key:"available_for_builder") { value }
              mf_hcp_bands: metafield(namespace:"fit", key:"hcp_bands") { value }
              mf_iron_profile: metafield(namespace:"fit", key:"iron_profile") { value }
              mf_iron_profiles: metafield(namespace:"fit", key:"iron_profiles") { value }
              mf_wedge_type: metafield(namespace:"fit", key:"wedge_type") { value }
              mf_loft_deg: metafield(namespace:"fit", key:"loft_deg") { value }
              mf_club_number: metafield(namespace:"fit", key:"club_number") { value }
              mf_length_class: metafield(namespace:"fit", key:"length_class") { value }
              mf_putter_type: metafield(namespace:"fit", key:"putter_type") { value }
              mf_flex_raw: metafield(namespace:"fit", key:"flex_raw") { value }
            }
          }
        }
      }
    `;
    const filters = [{ available: true }];

    let out = [];
    let after = null;

    for (let i = 0; i < 20; i++) {
      const data = await storefrontFetch(query, { handle, first: 100, after, filters });
      const conn = data?.collection?.products;
      if (!conn) break;

      const nodes = conn.nodes || [];
      for (const n of nodes) {
        n.__metafields = {
          club_type: n.mf_club_type?.value ?? null,
          gender: n.mf_gender?.value ?? null,
          hand: n.mf_hand?.value ?? null,
          available_for_builder: n.mf_available_for_builder?.value ?? null,
          hcp_bands: n.mf_hcp_bands?.value ?? null,
          iron_profile: n.mf_iron_profile?.value ?? null,
          iron_profiles: n.mf_iron_profiles?.value ?? null,
          wedge_type: n.mf_wedge_type?.value ?? null,
          loft_deg: n.mf_loft_deg?.value ?? null,
          club_number: n.mf_club_number?.value ?? null,
          length_class: n.mf_length_class?.value ?? null,
          putter_type: n.mf_putter_type?.value ?? null,
          flex_raw: n.mf_flex_raw?.value ?? null
        };
      }

      out = out.concat(nodes);
      if (!conn.pageInfo?.hasNextPage) break;
      after = conn.pageInfo.endCursor;
    }
    return out;
  }

  async function fetchProductsForCategory(catKey) {
    const handle = collectionHandleForCategory(catKey) || CFG.collections.all;
    const products = await fetchProductsFromCollection(handle);

    const desiredClubType = (catKey === "wedges") ? "wedge" : catKey;
    const gender = state.profile.gender;
    const hand = state.profile.hand;

    let filtered = products.filter(p => {
      const mf = productMetafieldsToObj(p);

      if (!mf.available_for_builder) return false;
      if (!p.availableForSale) return false;
      if (p.variants?.nodes?.[0] && !p.variants.nodes[0].availableForSale) return false;

      if (!mf.club_type || !mf.gender || !mf.hand) return false;

      if (mf.club_type !== desiredClubType) return false;
      if (gender && mf.gender !== gender) return false;
      if (hand && mf.hand !== hand) return false;

      return true;
    });

    const def = CATEGORY[catKey];
    state.usedFlexFallback = false;

    if (def?.needsFlex) {
      const wantGender = state.profile.gender;
      const speed = state.profile.speedBucket;
      const allow = allowedFlexes(wantGender, speed);

      const good = filtered.filter(p => {
        const mf = productMetafieldsToObj(p);
        const f = mf.flex_raw;
        if (!f) return false;
        if (wantGender === "men" && ["L","W","UL"].includes(f)) return false;
        return allow.includes(f);
      });

      if (good.length >= 4) {
        filtered = good;
      } else {
        const soft = filtered.filter(p => {
          const f = productMetafieldsToObj(p).flex_raw;
          if (wantGender === "men" && ["L","W","UL"].includes(f)) return false;
          return !!f;
        });
        filtered = soft;
        state.usedFlexFallback = true;
      }
    }

    return filtered;
  }

  // ---------- Cart ----------
  async function getCart() {
    const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, { headers: { "Accept": "application/json" } });
    return res.json();
  }

  async function addToCart(variantIdNumeric, quantity = 1, properties = {}) {
    const res = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        items: [{ id: Number(variantIdNumeric), quantity, properties }]
      })
    });
    if (!res.ok) {
      let msg = "Konnte nicht in den Warenkorb legen.";
      try {
        const j = await res.json();
        msg = j?.description || j?.message || msg;
      } catch {}
      throw new Error(msg);
    }
    return res.json();
  }

  function cartBuilderTotals(cart) {
    const items = (cart?.items || []).filter(it => it?.properties && (it.properties._nc_builder === "true" || it.properties._nc_builder === true));
    const total = items.reduce((sum, it) => sum + (Number(it.final_line_price || 0) / 100), 0);
    return { items, total };
  }

  async function refreshBudgetUI() {
    const budget = Number(state.profile.budget || 0);
    ui.total.textContent = moneyEUR(budget);
    try {
      const cart = await getCart();
      const { total } = cartBuilderTotals(cart);
      ui.used.textContent = moneyEUR(total);
      const rest = clamp(budget - total, -999999, 999999);
      ui.rest.textContent = `(${moneyEUR(rest)} übrig)`;
      const pct = budget > 0 ? clamp((total / budget) * 100, 0, 110) : 0;
      ui.barFill.style.width = `${pct}%`;
    } catch {
      ui.used.textContent = moneyEUR(0);
      ui.rest.textContent = `(${moneyEUR(budget)} übrig)`;
      ui.barFill.style.width = `0%`;
    }
  }

  // ---------- Recommendation logic ----------
  function preferredIronProfilesForBand(band) {
    if (band === "29-54") return ["max_forgiveness","forgiveness","game_improvement","super_gi"];
    if (band === "19-28") return ["forgiveness","game_improvement","balanced","distance"];
    if (band === "10-18") return ["balanced","players_distance","distance","forged_gi"];
    return ["players","blade","players_cavity","tour"];
  }

  function loftInRange(loft, a, b) {
    if (!Number.isFinite(loft)) return false;
    return loft >= a && loft <= b;
  }

  function getRemainingBudgetShares() {
    const active = state.categories.slice(state.currentCatIndex);
    const base = active.reduce((sum, k) => sum + (CATEGORY[k]?.share ?? 0.1), 0) || 1;
    const shares = {};
    for (const k of active) shares[k] = (CATEGORY[k]?.share ?? 0.1) / base;
    return shares;
  }

  function clubNumberBoost(catKey, clubNumberUpper) {
    if (!clubNumberUpper) return 0;
    const sp = state.profile.speedBucket;

    if (catKey === "fairway_wood") {
      if (sp === "fast") return clubNumberUpper === "3W" ? 10 : (clubNumberUpper === "5W" ? 6 : 0);
      if (sp === "moderate") return clubNumberUpper === "5W" ? 10 : (clubNumberUpper === "3W" ? 4 : 0);
      return clubNumberUpper === "7W" ? 10 : (clubNumberUpper === "5W" ? 8 : (clubNumberUpper === "3W" ? -6 : 2));
    }
    if (catKey === "hybrid") {
      if (sp === "fast") return clubNumberUpper === "2H" ? 10 : (clubNumberUpper === "3H" ? 6 : 0);
      if (sp === "moderate") return clubNumberUpper === "4H" ? 10 : (clubNumberUpper === "3H" ? 6 : 0);
      return clubNumberUpper === "5H" ? 10 : (clubNumberUpper === "6H" ? 6 : 0);
    }
    return 0;
  }

  function scoreProduct(p, catKey, subKey = null) {
    const mf = productMetafieldsToObj(p);
    const price = Number(p.priceRange?.minVariantPrice?.amount || 0);
    const budget = Number(state.profile.budget || 0);
    const shares = getRemainingBudgetShares();
    const target = budget * (shares[catKey] ?? CATEGORY[catKey]?.share ?? 0.1);

    const reasons = [];
    let score = 0;

    if (state.profile.brands?.length && state.profile.brands.includes(p.vendor)) {
      score += 8; reasons.push("Marke");
    }

    if (budget > 0) {
      if (price <= target) { score += 10; reasons.push("Budget"); }
      else if (price <= target * 1.15) { score += 3; reasons.push("Budget"); }
      else { score -= 8; }
    }

    if (catKey === "iron_set") {
      const band = state.profile.hcpBand;
      const bands = mf.hcp_bands || [];
      if (bands.includes(band)) { score += 40; reasons.push("Handicap"); }
      else if (bands.length) { score -= 80; } else { score -= 25; }

      const preferred = preferredIronProfilesForBand(band);
      const profiles = dedupe([mf.iron_profile, ...mf.iron_profiles]).filter(Boolean);
      if (profiles.length) {
        const ok = profiles.some(x => preferred.includes(x));
        score += ok ? 25 : -10;
        if (ok) reasons.push("Eisen-Typ");
      }

      score += flexScore(mf.flex_raw, state.profile.gender, state.profile.speedBucket);
      reasons.push("Flex");

      const wantLen = getHeightLengthClass(state.profile.heightCm);
      if (mf.length_class) score += (mf.length_class === wantLen ? 10 : -6);

    } else if (catKey === "driver" || catKey === "fairway_wood" || catKey === "hybrid") {
      score += flexScore(mf.flex_raw, state.profile.gender, state.profile.speedBucket);
      reasons.push("Flex");

      if (catKey !== "driver") {
        score += clubNumberBoost(catKey, mf.club_number);
        if (mf.club_number) reasons.push("Nummer");
      }
      if (mf.hcp_bands?.includes(state.profile.hcpBand)) score += 4;

    } else if (catKey === "wedges") {
      const loft = mf.loft_deg;
      if (subKey === "GW") score += loftInRange(loft, 48, 52) ? 30 : -20;
      if (subKey === "SW") score += loftInRange(loft, 54, 58) ? 30 : -20;
      if (subKey === "LW") score += loftInRange(loft, 58, 60) ? 30 : -20;

      const wantLen = getHeightLengthClass(state.profile.heightCm);
      if (mf.length_class) score += (mf.length_class === wantLen ? 8 : -4);

    } else if (catKey === "putter") {
      const want = state.profile.putterType;
      const has = (mf.putter_type || "");
      if (has && has.includes(want)) { score += 30; reasons.push(want === "mallet" ? "Mallet" : "Blade"); }
      else if (has) score -= 25;
    }

    if (!p.availableForSale) score -= 999;
    return { score, reasons: dedupe(reasons).slice(0, 3) };
  }

  // ---------- UI ----------
  function setStepper(active) {
    ui.stepper.forEach(btn => btn.classList.toggle("is-active", Number(btn.dataset.step) === active));
  }

  function setNavButtons({ back = true, next = true, skip = true, nextLabel = "Weiter", skipLabel = "Überspringen" } = {}) {
    (ui.back || []).forEach(b => b.hidden = !back);
    (ui.skip || []).forEach(b => b.hidden = !skip);
    (ui.next || []).forEach(b => b.hidden = !next);
    (ui.next || []).forEach(b => b.textContent = nextLabel);
    (ui.skip || []).forEach(b => b.textContent = skipLabel);
  }

  function render() {
    setStepper(state.step);
    if (state.step === 0) renderSetStep();
    else if (state.step === 1) renderProfileStep();
    else if (state.step === 2) renderClubStep();
    else renderSummaryStep();
  }

  function renderSetStep() {
    setNavButtons({ back: false, next: true, skip: false, nextLabel: "Weiter" });

    ui.main.innerHTML = `
      <div class="nc-card">
        <h2 class="nc-h2">Welche Zusammenstellung möchtest du?</h2>
        <p class="nc-muted">Bitte wähle zuerst eine Set-Art. Es ist bewusst nichts vorausgewählt.</p>

        <div class="nc-pillRow" role="group" aria-label="Set-Auswahl">
          <button class="nc-pill ${state.setType==="full"?"is-on":""}" data-set="full" type="button">Komplettset (12–14)</button>
          <button class="nc-pill ${state.setType==="half"?"is-on":""}" data-set="half" type="button">Halbsatz (6–10)</button>
          <button class="nc-pill ${state.setType==="custom"?"is-on":""}" data-set="custom" type="button">Freie Wahl</button>
        </div>

        <div class="nc-card" style="margin-top:12px;">
          <h2 class="nc-h2" style="margin-bottom:6px;">Kategorien</h2>
          <p class="nc-muted" style="margin-top:0;">Klicke, um Kategorien ein/auszuschalten.</p>
          <div class="nc-pillRow" id="nc-cat-pills"></div>
        </div>

        <p class="nc-muted" id="nc-set-warn" style="margin-top:12px;"></p>
      </div>
    `;

    const pills = $("#nc-cat-pills", ui.main);
    const warn = $("#nc-set-warn", ui.main);
    const allCats = ["driver","fairway_wood","hybrid","iron_set","wedges","putter"];

    function applySetType(setType) {
      state.setType = setType;
      if (setType === "full") state.categories = ["driver","fairway_wood","hybrid","iron_set","wedges","putter"];
      else if (setType === "half") state.categories = ["fairway_wood","hybrid","iron_set","wedges","putter"];
      else state.categories = ["driver","fairway_wood","hybrid","iron_set","wedges","putter"];
      state.currentCatIndex = 0;
      refreshCatPills();
      refreshNextDisabled();
    }

    function refreshCatPills() {
      pills.innerHTML = "";
      for (const k of allCats) {
        const on = state.categories.includes(k);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = `nc-pill ${on ? "is-on":""}`;
        btn.textContent = CATEGORY[k]?.label ?? k;
        btn.dataset.cat = k;
        pills.appendChild(btn);
      }
    }

    function refreshNextDisabled() {
      const ok = !!state.setType && state.categories.length > 0;
      (ui.next||[]).forEach(b => b.disabled = !ok);
      warn.textContent = ok ? "" : "Bitte wähle eine Set-Art (und mindestens eine Kategorie).";
    }

    $$('.nc-pill[data-set]', ui.main).forEach(b => {
      b.addEventListener("click", () => {
        $$('.nc-pill[data-set]', ui.main).forEach(x => x.classList.remove("is-on"));
        b.classList.add("is-on");
        applySetType(b.dataset.set);
      });
    });

    pills.addEventListener("click", (e) => {
      const btn = e.target.closest(".nc-pill[data-cat]");
      if (!btn) return;
      if (!state.setType) { toast("Erst Set-Art", "Bitte zuerst Komplettset/Halbsatz/Freie Wahl wählen."); return; }
      const k = btn.dataset.cat;
      const on = state.categories.includes(k);
      if (on) state.categories = state.categories.filter(x => x !== k);
      else state.categories = dedupe(state.categories.concat([k]));
      if (state.categories.length === 0) state.categories = ["iron_set"];
      refreshCatPills();
      refreshNextDisabled();
    });

    refreshCatPills();
    refreshNextDisabled();
    refreshBudgetUI();
  }

  function renderProfileStep() {
    setNavButtons({ back: true, next: true, skip: false, nextLabel: "Zu den Schlägern" });
    const p = state.profile;

    ui.main.innerHTML = `
      <div class="nc-card">
        <h2 class="nc-h2">Dein Profil</h2>
        <p class="nc-muted">Bitte fülle die Felder aus (keine Vorauswahl). Das beeinflusst vor allem Flex/Tempo und bei Eisen zusätzlich Handicap.</p>

        <div class="nc-grid2">
          <label class="nc-field">
            <span>Geschlecht*</span>
            <select id="nc-gender">
              <option value="" ${p.gender? "":"selected"} disabled>Bitte wählen…</option>
              <option value="men" ${p.gender==="men"?"selected":""}>Herren</option>
              <option value="women" ${p.gender==="women"?"selected":""}>Damen</option>
            </select>
          </label>

          <label class="nc-field">
            <span>Handseite*</span>
            <select id="nc-hand">
              <option value="" ${p.hand? "":"selected"} disabled>Bitte wählen…</option>
              <option value="RH" ${p.hand==="RH"?"selected":""}>Rechtshänder (RH)</option>
              <option value="LH" ${p.hand==="LH"?"selected":""}>Linkshänder (LH)</option>
            </select>
          </label>
        </div>

        <div class="nc-grid2">
          <label class="nc-field">
            <span>Handicap-Klasse*</span>
            <select id="nc-hcp">
              <option value="" ${p.hcpBand? "":"selected"} disabled>Bitte wählen…</option>
              ${HCP_BANDS.map(b => `<option value="${b.key}" ${p.hcpBand===b.key?"selected":""}>${b.label}</option>`).join("")}
            </select>
          </label>

          <label class="nc-field">
            <span>Körpergröße (cm)*</span>
            <input id="nc-height" type="number" min="120" max="220" placeholder="z. B. 178" value="${p.heightCm ?? ""}">
            <div class="nc-small">Länge (Eisen/Wedges): <strong id="nc-len-out">${p.heightCm ? esc(getHeightLengthClass(p.heightCm)) : "—"}</strong></div>
          </label>
        </div>

        <div class="nc-grid2">
          <label class="nc-field">
            <span>Schwunggeschwindigkeit Eisen 7 (mph) – optional</span>
            <input id="nc-mph" type="number" min="40" max="120" placeholder="z. B. 85" value="${p.speedMph7i ?? ""}">
            <div class="nc-small">Wenn leer: wähle bitte eine Einschätzung.</div>
          </label>

          <label class="nc-field">
            <span>Einschätzung Tempo*</span>
            <select id="nc-speed">
              <option value="" ${p.speedBucket? "":"selected"} disabled>Bitte wählen…</option>
              ${SPEED_BUCKETS.map(b => `<option value="${b.key}" ${p.speedBucket===b.key?"selected":""}>${b.label}</option>`).join("")}
            </select>
          </label>
        </div>

        <div class="nc-grid2">
          <label class="nc-field">
            <span>Gesamtbudget (EUR)*</span>
            <input id="nc-budget" type="number" min="100" step="10" placeholder="z. B. 900" value="${p.budget ?? ""}">
          </label>

          <label class="nc-field">
            <span>Putter-Form*</span>
            <select id="nc-putter">
              <option value="" ${p.putterType? "":"selected"} disabled>Bitte wählen…</option>
              <option value="mallet" ${p.putterType==="mallet"?"selected":""}>Mallet</option>
              <option value="blade" ${p.putterType==="blade"?"selected":""}>Blade</option>
            </select>
          </label>
        </div>

        <div class="nc-card" style="margin-top:12px;">
          <h2 class="nc-h2" style="margin-bottom:6px;">Markenpräferenz (optional)</h2>
          <div class="nc-pillRow" id="nc-brand-pills"></div>
        </div>

        <p class="nc-muted" id="nc-prof-warn" style="margin-top:12px;"></p>
      </div>
    `;

    const warn = $("#nc-prof-warn", ui.main);

    const COMMON_BRANDS = ["Titleist","TaylorMade","Callaway","Ping","Cobra","Mizuno","Cleveland","Srixon","Wilson","Odyssey","Scotty Cameron"];
    const pills = $("#nc-brand-pills", ui.main);
    for (const b of COMMON_BRANDS) {
      const on = p.brands.includes(b);
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = `nc-pill ${on ? "is-on":""}`;
      btn.textContent = b;
      btn.dataset.brand = b;
      pills.appendChild(btn);
    }

    function refreshNextDisabled() {
      const ok = !!p.gender && !!p.hand && !!p.hcpBand && !!p.heightCm && !!p.speedBucket && !!p.budget && !!p.putterType;
      (ui.next||[]).forEach(b => b.disabled = !ok);
      warn.textContent = ok ? "" : "Bitte alle Pflichtfelder ausfüllen.";
      refreshBudgetUI();
    }

    $("#nc-gender", ui.main).addEventListener("change", (e) => { p.gender = e.target.value; refreshNextDisabled(); });
    $("#nc-hand", ui.main).addEventListener("change", (e) => { p.hand = e.target.value; refreshNextDisabled(); });
    $("#nc-hcp", ui.main).addEventListener("change", (e) => { p.hcpBand = e.target.value; refreshNextDisabled(); });
    $("#nc-putter", ui.main).addEventListener("change", (e) => { p.putterType = e.target.value; refreshNextDisabled(); });

    $("#nc-height", ui.main).addEventListener("input", (e) => {
      const v = Number(e.target.value || 0);
      p.heightCm = v ? clamp(v, 120, 220) : null;
      $("#nc-len-out", ui.main).textContent = p.heightCm ? getHeightLengthClass(p.heightCm) : "—";
      refreshNextDisabled();
    });

    $("#nc-mph", ui.main).addEventListener("input", (e) => {
      const n = Number(e.target.value);
      if (Number.isFinite(n) && n > 0) p.speedMph7i = n;
      else p.speedMph7i = null;
    });

    $("#nc-speed", ui.main).addEventListener("change", (e) => { p.speedBucket = e.target.value; refreshNextDisabled(); });

    $("#nc-budget", ui.main).addEventListener("input", (e) => {
      const v = Number(e.target.value || 0);
      p.budget = v ? clamp(v, 0, 999999) : null;
      refreshNextDisabled();
    });

    pills.addEventListener("click", (e) => {
      const btn = e.target.closest(".nc-pill[data-brand]");
      if (!btn) return;
      const b = btn.dataset.brand;
      const on = p.brands.includes(b);
      if (on) p.brands = p.brands.filter(x => x !== b);
      else p.brands = dedupe(p.brands.concat([b]));
      btn.classList.toggle("is-on", !on);
    });

    refreshNextDisabled();
  }

  async function renderClubStep() {
    if (!state.categories.length) { state.step = 0; render(); return; }

    const catKey = state.categories[state.currentCatIndex];
    const def = CATEGORY[catKey];
    if (!def) return;

    let subKey = null;
    let titleSuffix = "";
    if (catKey === "wedges") {
      subKey = state.wedgeSubstep === 0 ? "GW" : state.wedgeSubstep === 1 ? "SW" : "LW";
      titleSuffix = subKey === "GW" ? " – Gap Wedge (48–52°)" : subKey === "SW" ? " – Sand Wedge (54–58°)" : " – Lob Wedge (58–60°)";
      if (state.wedgeSubstep === 2 && !state.includeLW) {
        state.wedgeSubstep = 0;
        nextCategory();
        return;
      }
    }

    setNavButtons({
      back: true,
      next: true,
      skip: true,
      nextLabel: (state.currentCatIndex === state.categories.length - 1 && catKey !== "wedges") ? "Zur Übersicht" : "Weiter",
      skipLabel: "Überspringen"
    });

    ui.main.innerHTML = `
      <div class="nc-card">
        <h2 class="nc-h2">${esc(def.label)}${esc(titleSuffix)}</h2>
        <p class="nc-muted" id="nc-cat-hint"></p>

        ${catKey === "wedges" ? `
          <div class="nc-card" style="margin-top:12px;">
            <div class="nc-grid2">
              <div>
                <div class="nc-small"><strong>Empfehlung:</strong> mindestens 1 Gap Wedge + 1 Sand Wedge.</div>
                <div class="nc-small">Lob Wedge ist optional.</div>
              </div>
              <label class="nc-check" style="justify-content:flex-end;">
                <input type="checkbox" id="nc-lw" ${state.includeLW ? "checked":""}>
                <span>Lob Wedge zusätzlich empfehlen</span>
              </label>
            </div>
          </div>
        ` : ``}

        <div class="nc-products" id="nc-products"></div>
        <div style="display:flex; justify-content:space-between; gap:10px; margin-top:14px; flex-wrap:wrap;">
          <a class="nc-link" href="#" data-action="show-more">Mehr anzeigen</a>
          <span class="nc-small" id="nc-count"></span>
        </div>

        <p class="nc-muted" id="nc-flex-note" style="margin-top:10px;"></p>
      </div>
    `;

    const hint = $("#nc-cat-hint", ui.main);
    hint.textContent = categoryHintText(catKey);

    const flexNote = $("#nc-flex-note", ui.main);
    flexNote.textContent = "";

    if (catKey === "wedges") {
      $("#nc-lw", ui.main).addEventListener("change", (e) => {
        state.includeLW = !!e.target.checked;
        toast("Gespeichert", state.includeLW ? "Lob Wedge wird zusätzlich empfohlen." : "Lob Wedge wird nicht empfohlen.");
      });
    }

    const productsEl = $("#nc-products", ui.main);
    const countEl = $("#nc-count", ui.main);

    productsEl.innerHTML = `<div class="nc-card nc-loading" style="grid-column:1/-1;"><div class="nc-skel"></div><div class="nc-skel"></div><div class="nc-skel"></div></div>`;

    let products = [];
    try {
      products = await fetchProductsForCategory(catKey);
    } catch (e) {
      productsEl.innerHTML = `
        <div class="nc-card" style="grid-column:1/-1;">
          <h2 class="nc-h2">Konfiguration fehlt</h2>
          <p class="nc-muted">${esc(e.message || "Fehler beim Laden der Produkte.")}</p>
          <p class="nc-muted">Bitte Token prüfen und sicherstellen, dass Produkte auf dem richtigen Kanal veröffentlicht sind.</p>
        </div>
      `;
      return;
    }

    if (state.usedFlexFallback && CATEGORY[catKey]?.needsFlex) {
      flexNote.textContent = "Hinweis: Es gibt wenige Treffer im gewünschten Flex – wir zeigen daher auch nahe Alternativen.";
    }

    const scored = products.map(p => {
      const mf = productMetafieldsToObj(p);
      const s = scoreProduct(p, catKey, subKey);
      const displayScore = toFitPercent(s.score);
      return { p, mf, ...s, displayScore };
    }).sort((a,b) => b.score - a.score);

    let limit = 10;
    renderList();

    function renderList() {
      const slice = scored.slice(0, limit);
      productsEl.innerHTML = slice.map((x, idx) => productCardHtml(x, catKey, subKey, idx)).join("");
      countEl.textContent = `${Math.min(limit, scored.length)} von ${scored.length} angezeigt`;

      $$(".nc-prod [data-action='add']", productsEl).forEach(btn => {
        btn.addEventListener("click", async () => {
          const variantId = btn.dataset.variant;
          const title = btn.dataset.title;
          const price = Number(btn.dataset.price || 0);
          const vendor = btn.dataset.vendor;
          if (!variantId) { toast("Fehlt", "Keine Variant-ID gefunden."); return; }

          btn.disabled = true;
          btn.textContent = "Wird hinzugefügt…";
          try {
            await addToCart(variantId, 1, { _nc_builder: "true", nc_category: catKey, nc_sub: subKey || "" });
            state.selected.push({ categoryKey: catKey, subKey, variantId, title, price, vendor });
            toast("Im Warenkorb", title);
            await refreshBudgetUI();
            btn.textContent = "Im Warenkorb ✓";
            btn.disabled = true;
          } catch (e) {
            btn.disabled = false;
            btn.textContent = "In den Warenkorb";
            toast("Fehler", e.message || "Konnte nicht in den Warenkorb legen.");
          }
        });
      });
    }

    $('[data-action="show-more"]', ui.main).addEventListener("click", (e) => {
      e.preventDefault();
      limit = Math.min(scored.length, limit + 20);
      renderList();
    });

    refreshBudgetUI();
  }

  function productCardHtml(x, catKey, subKey, idx) {
    const p = x.p;
    const mf = x.mf;
    const price = Number(p.priceRange?.minVariantPrice?.amount || 0);
    const variantGid = p.variants?.nodes?.[0]?.id;
    const variantId = toNumericVariantId(variantGid);
    const img = p.featuredImage?.url || "";

    const chips = buildChips(mf, x.reasons, catKey, subKey);

    return `
      <article class="nc-prod" data-idx="${idx}">
        <div class="nc-prod__img">
          ${img ? `<img src="${esc(img)}" alt="${esc(p.featuredImage?.altText || p.title)}" loading="lazy">` : `<span class="nc-small">Kein Bild</span>`}
        </div>
        <div>
          <h3 class="nc-prod__title">${esc(p.title)}</h3>
          <div class="nc-prod__meta">
            <span class="nc-chip">${esc(p.vendor || "—")}</span>
            ${mf.flex_raw ? `<span class="nc-chip">Flex: ${esc(mf.flex_raw)}</span>` : ``}
            ${mf.club_number ? `<span class="nc-chip">${esc(mf.club_number)}</span>` : ``}
            ${Number.isFinite(mf.loft_deg) ? `<span class="nc-chip">${esc(mf.loft_deg)}°</span>` : ``}
            ${mf.length_class ? `<span class="nc-chip">${esc(mf.length_class)}</span>` : ``}
            ${mf.putter_type ? `<span class="nc-chip">${esc(mf.putter_type)}</span>` : ``}
          </div>

          <div class="nc-pillRow" style="margin-top:8px;">
            ${chips.map(c => `<span class="nc-chip">${esc(c)}</span>`).join("")}
          </div>

          <div class="nc-prod__bottom">
            <div>
              <div class="nc-price">${moneyEUR(price)}</div>
              <div class="nc-small">Passform: ${x.displayScore}/100</div>
            </div>
            <div style="display:flex; gap:10px; align-items:center;">
              <a class="nc-link" href="/products/${encodeURIComponent(p.handle)}" target="_blank" rel="noopener">Ansehen</a>
              <button class="nc-btn nc-btn--primary" data-action="add"
                data-variant="${esc(variantId)}"
                data-title="${esc(p.title)}"
                data-price="${esc(price)}"
                data-vendor="${esc(p.vendor||"")}"
                ${!variantId ? "disabled":""}
              >In den Warenkorb</button>
            </div>
          </div>
        </div>
      </article>
    `;
  }

  function buildChips(mf, reasons) {
    const out = [];
    for (const r of reasons || []) {
      if (r === "Flex") out.push("Flex passend");
      else if (r === "Handicap") out.push(`für ${state.profile.hcpBand}`);
      else if (r === "Budget") out.push("im Budget");
      else if (r === "Nummer") out.push("Schläger‑Nummer");
      else if (r === "Eisen-Typ") out.push("Eisen‑Typ");
      else out.push(r);
    }
    out.push(state.profile.gender === "men" ? "Herren" : "Damen");
    out.push(state.profile.hand || "");
    return out.filter(Boolean).slice(0, 5);
  }

  function categoryHintText(catKey) {
    const p = state.profile;
    const budget = Number(p.budget || 0);
    const shares = getRemainingBudgetShares();
    const target = budget * (shares[catKey] ?? CATEGORY[catKey]?.share ?? 0.1);

    if (catKey === "iron_set") return `Handicap ist hier am wichtigsten. Richtbudget: ${moneyEUR(target)}.`;
    if (catKey === "driver") return `Beim Driver ist Flex/Tempo wichtiger. Richtbudget: ${moneyEUR(target)}.`;
    if (catKey === "fairway_wood") return `Sortiert nach Flex/Tempo und Holz‑Nummer. Richtbudget: ${moneyEUR(target)}.`;
    if (catKey === "hybrid") return `Sortiert nach Flex/Tempo und Hybrid‑Nummer. Richtbudget: ${moneyEUR(target)}.`;
    if (catKey === "wedges") return `Flex ist bei Wedges meist universal. Richtbudget: ${moneyEUR(target)}.`;
    if (catKey === "putter") return `Du hast ${p.putterType === "mallet" ? "Mallet" : "Blade"} gewählt. Richtbudget: ${moneyEUR(target)}.`;
    return `Richtbudget: ${moneyEUR(target)}.`;
  }

  function validateProfile() {
    const p = state.profile;
    return !!p.gender && !!p.hand && !!p.hcpBand && !!p.heightCm && !!p.speedBucket && !!p.budget && !!p.putterType;
  }

  function nextCategory() {
    state.wedgeSubstep = 0;
    if (state.currentCatIndex < state.categories.length - 1) state.currentCatIndex += 1;
    else state.step = 3;
    render();
  }

  function prevCategory() {
    state.wedgeSubstep = 0;
    if (state.currentCatIndex > 0) state.currentCatIndex -= 1;
    else state.step = 1;
    render();
  }

  function handleNext() {
    if (state.step === 0) {
      if (!state.setType) { toast("Bitte wählen", "Bitte zuerst die Set-Art wählen."); return; }
      if (!state.categories.length) { toast("Bitte wählen", "Bitte mindestens eine Kategorie wählen."); return; }
      state.step = 1;
      render(); return;
    }
    if (state.step === 1) {
      if (!validateProfile()) { toast("Fehlt noch was", "Bitte alle Pflichtfelder ausfüllen."); return; }
      state.step = 2;
      state.currentCatIndex = 0;
      state.wedgeSubstep = 0;
      render(); return;
    }
    if (state.step === 2) {
      const catKey = state.categories[state.currentCatIndex];
      if (catKey === "wedges") {
        if (state.wedgeSubstep === 0) { state.wedgeSubstep = 1; render(); return; }
        if (state.wedgeSubstep === 1) { state.wedgeSubstep = 2; render(); return; }
        state.wedgeSubstep = 0;
        nextCategory(); return;
      }
      nextCategory(); return;
    }
    if (state.step === 3) openContactModal();
  }

  function handleBack() {
    if (state.step === 1) { state.step = 0; render();
      scheduleScrollTop();
      return; }
    if (state.step === 2) {
      const catKey = state.categories[state.currentCatIndex];
      if (catKey === "wedges" && state.wedgeSubstep > 0) { state.wedgeSubstep -= 1; render(); return; }
      prevCategory(); return;
    }
    if (state.step === 3) { state.step = 2; state.currentCatIndex = Math.max(0, state.categories.length - 1); render(); return; }
  }

  function handleSkip() {
    if (state.step !== 2) return;
    const catKey = state.categories[state.currentCatIndex];

    if (catKey === "wedges") {
      if (state.wedgeSubstep === 0) state.wedgeSubstep = 1;
      else if (state.wedgeSubstep === 1) state.wedgeSubstep = 2;
      else { state.wedgeSubstep = 0; nextCategory(); return; }
      render(); return;
    }

    const removed = state.categories.splice(state.currentCatIndex, 1);
    toast("Übersprungen", `${CATEGORY[removed[0]]?.label || removed[0]} übersprungen.`);
    if (state.categories.length === 0) { state.step = 3; render(); return; }
    if (state.currentCatIndex >= state.categories.length) state.currentCatIndex = Math.max(0, state.categories.length - 1);
    render();
  }

  // ---------- Summary + Contact ----------
  function renderSummaryStep() {
    setNavButtons({ back: true, next: true, skip: false, nextLabel: "Weitere Beratung" });

    const sel = state.selected;
    const p = state.profile;

    ui.main.innerHTML = `
      <div class="nc-card">
        <h2 class="nc-h2">Übersicht</h2>
        <p class="nc-muted">Hier siehst du, was du bereits über den Builder in den Warenkorb gelegt hast.</p>

        <div class="nc-card" style="margin-top:12px;">
          <div class="nc-grid2">
            <div>
              <div class="nc-small"><strong>Profil</strong></div>
              <div class="nc-small">${p.gender === "men" ? "Herren" : "Damen"} • ${p.hand} • HCP ${p.hcpBand} • ${p.heightCm}cm • Tempo: ${p.speedBucket}</div>
              <div class="nc-small">Budget: ${moneyEUR(p.budget)}</div>
            </div>
            <div style="text-align:right;">
              <a class="nc-link" href="/cart" target="_blank" rel="noopener">Warenkorb öffnen →</a>
            </div>
          </div>
        </div>

        <div class="nc-card" style="margin-top:12px;">
          <div class="nc-grid2">
            <div>
              <div class="nc-small"><strong>Hinzugefügt</strong></div>
              <div class="nc-small">${sel.length ? `${sel.length} Artikel.` : `Noch nichts hinzugefügt.`}</div>
            </div>
            <div style="text-align:right;">
              <button type="button" class="nc-btn nc-btn--ghost" data-action="restart">Neu starten</button>
            </div>
          </div>

          <div style="margin-top:12px; display:grid; gap:10px;">
            ${sel.length ? sel.slice(-12).reverse().map(it => `
              <div class="nc-prod" style="grid-template-columns:1fr;">
                <div style="display:flex; justify-content:space-between; gap:10px; flex-wrap:wrap; align-items:center;">
                  <div>
                    <div style="font-weight:950;">${esc(it.title)}</div>
                    <div class="nc-small">${esc(CATEGORY[it.categoryKey]?.label || it.categoryKey)}${it.subKey ? " • "+esc(it.subKey) : ""} • ${esc(it.vendor || "")}</div>
                  </div>
                  <div style="font-weight:950;">${moneyEUR(it.price)}</div>
                </div>
              </div>
            `).join("") : `<p class="nc-muted" style="margin:12px 0 0;">Tipp: Geh zurück zu „Schläger“, um Empfehlungen zu sehen und Artikel hinzuzufügen.</p>`}
          </div>
        </div>
      </div>
    `;

    $('[data-action="restart"]', ui.main).addEventListener("click", () => {
      state.step = 0;
      state.setType = null;
      state.categories = [];
      state.currentCatIndex = 0;
      state.wedgeSubstep = 0;
      state.includeLW = false;
      state.usedFlexFallback = false;
      state.profile = { gender:null, hand:null, hcpBand:null, heightCm:null, speedMph7i:null, speedBucket:null, budget:null, brands:[], putterType:null };
      state.selected = [];
      render();
    });

    refreshBudgetUI();
  }

  function openContactModal() {
    const p = state.profile;
    const summary = [];
    summary.push(`Profil: ${p.gender === "men" ? "Herren" : "Damen"}, Hand ${p.hand}, HCP ${p.hcpBand}, Größe ${p.heightCm}cm, Tempo ${p.speedBucket}${p.speedMph7i ? ` (${p.speedMph7i} mph 7i)` : ""}`);
    summary.push(`Budget: ${p.budget} EUR`);
    if (p.brands?.length) summary.push(`Marken: ${p.brands.join(", ")}`);
    summary.push(`Putter: ${p.putterType}`);
    summary.push(`Kategorien: ${state.categories.join(", ")}`);
    if (state.selected.length) {
      summary.push(`\nBereits im Warenkorb (Builder):`);
      for (const it of state.selected) summary.push(`- ${CATEGORY[it.categoryKey]?.label || it.categoryKey}${it.subKey ? ` (${it.subKey})` : ""}: ${it.title} (${it.price} EUR)`);
    } else {
      summary.push(`\nKeine Artikel über den Builder hinzugefügt.`);
    }
    ui.contactMessage.value = summary.join("\n");
    ui.modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeContactModal() {
    ui.modal.hidden = true;
    document.body.style.overflow = "";
  }

  root.addEventListener("click", (e) => {
    const a = e.target.closest("[data-action]");
    if (!a) return;
    if (a.dataset.action === "close-modal") closeContactModal();
  });

  ui.contactForm.addEventListener("submit", () => {
    if (CFG.contactSuccessUrl) setTimeout(() => { window.location.href = CFG.contactSuccessUrl; }, 300);
  });

  // Footer nav events
  (ui.next||[]).forEach(b => b.addEventListener("click", handleNext));
  (ui.back||[]).forEach(b => b.addEventListener("click", handleBack));
  (ui.skip||[]).forEach(b => b.addEventListener("click", handleSkip));

  // Stepper click: only backwards
  ui.stepper.forEach(btn => {
    btn.addEventListener("click", () => {
      const s = Number(btn.dataset.step);
      if (s < state.step) { state.step = s; render(); scheduleScrollTop(); }
    });
  });

  // Init
  ui.main.innerHTML = `<div class="nc-card"><h2 class="nc-h2">Lade Builder…</h2><p class="nc-muted">Einen Moment.</p></div>`;
  refreshBudgetUI().finally(() => { render(); scheduleScrollTop(); });

})();